import Config from 'config';
import { sample } from 'effector';
import { t } from 'i18next';
import $$api from 'models/api';
import $$auth from 'models/auth';
import $$weakPassword from 'models/change-weak-password';
import { showModal } from 'models/modals';
import { $global } from 'models/store-global';

import { rules } from 'components/FormControl/Password/PasswordHint';

import LoginAsUserService from 'services/LoginAsUserService';
import { opposite } from 'utils/common-helper';

const { isMarketing } = Config;

$$weakPassword.$changeRequired.reset($$auth.$isAuthenticated.updates.filter({ fn: opposite }));

sample({
    source: {
        role: $global.map((state) => state.auth?.userRole || 'guest'),
        isPasswordChangeRequired: $$auth.$currentParticipant.map((p) => p?.isPasswordChangeRequired),
    },
    fn: ({ role, isPasswordChangeRequired }) =>
        role !== 'guest' && isPasswordChangeRequired === true && !isMarketing && !LoginAsUserService.isLoggedInAsUser(),
    target: $$weakPassword.$changeRequired,
});

const closeModalHandler = () => {
    $$weakPassword.modalClosed();
    setTimeout(() => {
        const oldPasswordInput = document.querySelector<HTMLInputElement>('input[name="old_password"]');
        if (oldPasswordInput) {
            oldPasswordInput.focus();
        }
    }, 250);
};

sample({
    clock: $$weakPassword.$changeRequired,
    filter: Boolean,
    fn: () => ({
        modalName: 'MODALITY' as const,
        state: {
            title: t('passwordChangeRequiredModal.title'),
            body: t('passwordChangeRequiredModal.body'),
            options: {
                confirmButton: 'Proceed',
                onConfirm: closeModalHandler,
                onCancel: closeModalHandler,
                displayCloseButton: false,
            },
        },
    }),
    target: showModal,
});

sample({
    source: $$auth.$currentParticipant.map((p) => p?.isPasswordChangeRequired),
    clock: [
        $$auth.signInFx.done.map(({ params }) => params.password),
        $$auth.signUpFx.done.map(({ params }) => params.password),
        $$auth.changePasswordFx.done.map(({ params }) => params.newPassword),
    ],
    filter: (isPasswordChangeRequired) => isPasswordChangeRequired === true,
    fn: (_, password) => !rules(t).every((rule) => password?.match(rule.regex)),
    target: $$api.users.setPasswordIsStrongFx,
});

sample({ clock: $$api.users.setPasswordIsStrongFx.done, target: $$api.participants.getMeFx });
